import Toast from '@eduzz/houston-ui/Toast';

enum enTypeToast {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info'
}

interface IToast {
  type: enTypeToast;
  message: string;
}

type Arrayish = { [n: number]: IToast };

const statusMessage: Arrayish = {
  200: {
    type: enTypeToast.SUCCESS,
    message: 'Salvo com sucesso'
  },
  201: {
    type: enTypeToast.SUCCESS,
    message: 'Salvo com sucesso'
  },
  400: {
    type: enTypeToast.ERROR,
    message: 'Erro ao salvar'
  },
  500: {
    type: enTypeToast.ERROR,
    message: 'Erro no servidor'
  }
};

export const renderToastMessageApi = (statusCode: number, message = '') => {
  const toastMessage = message || statusMessage[statusCode]?.message || statusMessage[500].message;
  const type = statusMessage[statusCode]?.type || enTypeToast.ERROR;
  Toast[type](toastMessage);
};
